import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { fetchTimerShop } from '../actions';
import { timeTrackingFlagEnabled } from '../selectors';

const shopAppFetchTimer = compose(
  connect(
    state => ({
      shop: state.auth.shop,
      timeTrackingEnabled: timeTrackingFlagEnabled(state),
    }),
    { fetchTimerShop }
  ),
  withHandlers({
    fetchTimer: props => () => {
      if (props.timeTrackingEnabled) props.fetchTimerShop(props.shop);
    },
  })
);

export default shopAppFetchTimer;
